'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var errcode = require('err-code');

var utils = require('../../utils');

module.exports = function (dht) {
  var log = utils.logger(dht.peerInfo.id, 'rpc:add-provider');
  /**
   * Process `AddProvider` DHT messages.
   *
   * @param {PeerInfo} peer
   * @param {Message} msg
   * @returns {Promise<void>}
   */

  return /*#__PURE__*/function () {
    var _addProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer, msg) {
      var cid, errMsg;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              log('start');

              if (!(!msg.key || msg.key.length === 0)) {
                _context.next = 3;
                break;
              }

              throw errcode(new Error('Missing key'), 'ERR_MISSING_KEY');

            case 3:
              _context.prev = 3;
              cid = new CID(msg.key);
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              errMsg = "Invalid CID: ".concat(_context.t0.message);
              throw errcode(new Error(errMsg), 'ERR_INVALID_CID');

            case 11:
              msg.providerPeers.forEach(function (pi) {
                // Ignore providers not from the originator
                if (!pi.id.isEqual(peer.id)) {
                  log('invalid provider peer %s from %s', pi.id.toB58String(), peer.id.toB58String());
                  return;
                }

                if (pi.multiaddrs.size < 1) {
                  log('no valid addresses for provider %s. Ignore', peer.id.toB58String());
                  return;
                }

                log('received provider %s for %s (addrs %s)', peer.id.toB58String(), cid.toBaseEncodedString(), pi.multiaddrs.toArray().map(function (m) {
                  return m.toString();
                }));

                if (!dht._isSelf(pi.id)) {
                  dht.peerStore.put(pi);
                  return dht.providers.addProvider(cid, pi.id);
                }
              }); // Previous versions of the JS DHT sent erroneous providers in the
              // `providerPeers` field. In order to accommodate older clients that have
              // this bug, we fall back to assuming the originator is the provider if
              // we can't find any valid providers in the payload.
              // https://github.com/libp2p/js-libp2p-kad-dht/pull/127
              // https://github.com/libp2p/js-libp2p-kad-dht/issues/128

              return _context.abrupt("return", dht.providers.addProvider(cid, peer.id));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 7]]);
    }));

    function addProvider(_x, _x2) {
      return _addProvider.apply(this, arguments);
    }

    return addProvider;
  }();
};